import React from "react";

import Typography from "@material-ui/core/Typography";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import BirthPlanForm from "./components/BirthPlanForm/BirthPlanForm";
import Container from "../../components/Container";
import theme from "../../constants/theme";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      paddingBottom: theme.spacing(8),
      backgroundColor: theme.palette.secondary.light,
      [theme.breakpoints.down("sm")]: {
        backgroundColor: "transparent",
        paddingBottom: 0,
      },
    },
    container: {
      backgroundColor: "#fff",
      paddingLeft: theme.spacing(7),
      paddingBottom: theme.spacing(7),
      [theme.breakpoints.down("sm")]: {
        paddingLeft: theme.spacing(3),
      },
    },
    title: {
      padding: theme.spacing(8, 0),
    },
  })
);

export default function BirthPlanFormPage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="lg" className={classes.container}>
        <Typography variant="h4" className={classes.title}>
          Moj plan poroda
        </Typography>
        <BirthPlanForm />
      </Container>
    </div>
  );
}
